// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/contract.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/contract.proto.
 */
export const file_bfftypes_v1_contract: GenFile = /*@__PURE__*/
  fileDesc("ChpiZmZ0eXBlcy92MS9jb250cmFjdC5wcm90bxILYmZmdHlwZXMudjEqoQEKHFBoeXNpY2FsQ29udHJhY3REZWxpdmVyeVR5cGUSLworUEhZU0lDQUxfQ09OVFJBQ1RfREVMSVZFUllfVFlQRV9VTlNQRUNJRklFRBAAEiYKIlBIWVNJQ0FMX0NPTlRSQUNUX0RFTElWRVJZX1RZUEVfQkcQARIoCiRQSFlTSUNBTF9DT05UUkFDVF9ERUxJVkVSWV9UWVBFX0pFUFgQAiqgAQoMRWNsZWFyT3B0aW9uEh0KGUVDTEVBUl9PUFRJT05fVU5TUEVDSUZJRUQQABIVChFFQ0xFQVJfT1BUSU9OXzFfMRABEhUKEUVDTEVBUl9PUFRJT05fMV8yEAISFQoRRUNMRUFSX09QVElPTl8xXzMQAxIVChFFQ0xFQVJfT1BUSU9OXzJfMRAEEhUKEUVDTEVBUl9PUFRJT05fMl8yEAUqowEKE01hcmdpbkNhbGxGcmVxdWVuY3kSJQohTUFSR0lOX0NBTExfRlJFUVVFTkNZX1VOU1BFQ0lGSUVEEAASHwobTUFSR0lOX0NBTExfRlJFUVVFTkNZX0RBSUxZEAESIAocTUFSR0lOX0NBTExfRlJFUVVFTkNZX1dFRUtMWRACEiIKHk1BUkdJTl9DQUxMX0ZSRVFVRU5DWV9CSVdFRUtMWRADKt4BChFNYXJnaW5DYWxsV2Vla2RheRIjCh9NQVJHSU5fQ0FMTF9XRUVLREFZX1VOU1BFQ0lGSUVEEAASHgoaTUFSR0lOX0NBTExfV0VFS0RBWV9NT05EQVkQARIfChtNQVJHSU5fQ0FMTF9XRUVLREFZX1RVRVNEQVkQAhIhCh1NQVJHSU5fQ0FMTF9XRUVLREFZX1dFRE5FU0RBWRADEiAKHE1BUkdJTl9DQUxMX1dFRUtEQVlfVEhVUlNEQVkQBBIeChpNQVJHSU5fQ0FMTF9XRUVLREFZX0ZSSURBWRAFKkcKB0NsZWFyZXISFwoTQ0xFQVJFUl9VTlNQRUNJRklFRBAAEhIKDkNMRUFSRVJfU1RPTkVYEAESDwoLQ0xFQVJFUl9LR0kQAkK0AQoPY29tLmJmZnR5cGVzLnYxQg1Db250cmFjdFByb3RvUAFaRWdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9iZmZ0eXBlcy92MTt0eXBlc6ICA0JYWKoCC0JmZnR5cGVzLlYxygILQmZmdHlwZXNcVjHiAhdCZmZ0eXBlc1xWMVxHUEJNZXRhZGF0YeoCDEJmZnR5cGVzOjpWMWIGcHJvdG8z");

/**
 * @generated from enum bfftypes.v1.PhysicalContractDeliveryType
 */
export enum PhysicalContractDeliveryType {
  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_JEPX = 2;
   */
  JEPX = 2,
}

/**
 * Describes the enum bfftypes.v1.PhysicalContractDeliveryType.
 */
export const PhysicalContractDeliveryTypeSchema: GenEnum<PhysicalContractDeliveryType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_contract, 0);

/**
 * @generated from enum bfftypes.v1.EclearOption
 */
export enum EclearOption {
  /**
   * @generated from enum value: ECLEAR_OPTION_UNSPECIFIED = 0;
   */
  ECLEAR_OPTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_1 = 1;
   */
  ECLEAR_OPTION_1_1 = 1,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_2 = 2;
   */
  ECLEAR_OPTION_1_2 = 2,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_3 = 3;
   */
  ECLEAR_OPTION_1_3 = 3,

  /**
   * @generated from enum value: ECLEAR_OPTION_2_1 = 4;
   */
  ECLEAR_OPTION_2_1 = 4,

  /**
   * @generated from enum value: ECLEAR_OPTION_2_2 = 5;
   */
  ECLEAR_OPTION_2_2 = 5,
}

/**
 * Describes the enum bfftypes.v1.EclearOption.
 */
export const EclearOptionSchema: GenEnum<EclearOption> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_contract, 1);

/**
 * @generated from enum bfftypes.v1.MarginCallFrequency
 */
export enum MarginCallFrequency {
  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_BIWEEKLY = 3;
   */
  BIWEEKLY = 3,
}

/**
 * Describes the enum bfftypes.v1.MarginCallFrequency.
 */
export const MarginCallFrequencySchema: GenEnum<MarginCallFrequency> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_contract, 2);

/**
 * @generated from enum bfftypes.v1.MarginCallWeekday
 */
export enum MarginCallWeekday {
  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_MONDAY = 1;
   */
  MONDAY = 1,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_TUESDAY = 2;
   */
  TUESDAY = 2,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_WEDNESDAY = 3;
   */
  WEDNESDAY = 3,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_THURSDAY = 4;
   */
  THURSDAY = 4,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_FRIDAY = 5;
   */
  FRIDAY = 5,
}

/**
 * Describes the enum bfftypes.v1.MarginCallWeekday.
 */
export const MarginCallWeekdaySchema: GenEnum<MarginCallWeekday> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_contract, 3);

/**
 * @generated from enum bfftypes.v1.Clearer
 */
export enum Clearer {
  /**
   * @generated from enum value: CLEARER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLEARER_STONEX = 1;
   */
  STONEX = 1,

  /**
   * @generated from enum value: CLEARER_KGI = 2;
   */
  KGI = 2,
}

/**
 * Describes the enum bfftypes.v1.Clearer.
 */
export const ClearerSchema: GenEnum<Clearer> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_contract, 4);

